
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  SalesManagerContactResource,
} from '../models';
import {
    SalesManagerContactResourceFromJSON,
    SalesManagerContactResourceToJSON,
} from '../models';

/**
 * 
 */
export class ClientSalesManagerContactApi extends runtime.BaseAPI {

    /**
          */
    async getSalesManagerContactRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SalesManagerContactResource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<SalesManagerContactResource>({
            path: `/navbar/api/sales-manager-contact`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SalesManagerContactResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getSalesManagerContact(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SalesManagerContactResource> {
        const response = await this.getSalesManagerContactRaw(initOverrides);
        return response._data;
    }

}
